import React from 'react';
import UpIcon from '../../../img/collapse-icon-up.svg';

const CollapseIcon = React.memo(({ isActive }) => (
  <img
    src={UpIcon}
    alt="Toggle"
    style={{
      width: '24px',
      height: '24px',
      transition: 'transform 0.3s ease',
      transform: isActive ? 'rotate(0deg)' : 'rotate(180deg)',
    }}
  />
));

CollapseIcon.displayName = 'CollapseIcon';

export default CollapseIcon;